import React, {Component} from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import {GRAPH_MARGIN, WHITOUT_INFORMATION} from "../utils/constants";

var Loader = require('react-loader');

class AgreementAcommplishment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      datas: [
        {mes: "Ene", percentage: 78},
        {mes: "Feb", percentage: 90},
        {mes: "Mar", percentage: 84},
        {mes: "Abr", percentage: 56},
        {mes: "May", percentage: 12},
        {mes: "Jun", percentage: 100},
        {mes: "Jul", percentage: 80},
        {mes: "Ago", percentage: 60},
        {mes: "Sep", percentage: 15},
        {mes: "Oct", percentage: 20},
        {mes: "Nov", percentage: 63},
        {mes: "Dic", percentage: 78},
      ], loaded: false
    };
  }

  componentDidMount() {
  }

  render() {
    if (this.state.datas.length > 0) {
      return (
        <ResponsiveContainer>
          <BarChart width={600} height={300} data={this.state.datas}
                    margin={GRAPH_MARGIN}>
            <XAxis dataKey="mes"/>
            <YAxis unit={"%"} domain={[0, 100]}/>
            <CartesianGrid/>
            <Tooltip/>
            <Legend verticalAlign={"top"}/>
            <Bar name={"Porcentaje"} dataKey="percentage" stackId="a" fill="#222"/>
            <Brush dataKey={"mes"} height={20}/>
          </BarChart>
        </ResponsiveContainer>
      );
    } else {
      return (
        <Loader loaded={this.state.loaded} top="50%"><h2
          className="without-avilable-information">{WHITOUT_INFORMATION}</h2>
        </Loader>);
    }

  }
}

export default AgreementAcommplishment





// WEBPACK FOOTER //
// ./src/charts/agreementAcommplishment.js